"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.KI = void 0;
exports.KI = {
    numericCode: '296',
    alpha2Code: 'KI',
    alpha3Code: 'KIR',
    englishName: {
        short: 'Kiribati',
        full: 'the Republic of Kiribati',
    },
    names: {
        full: {
            en: 'the Republic of Kiribati',
            fr: 'la République de Kiribati',
            '': 'Kiribati',
        },
        short: {
            en: 'Kiribati',
            fr: 'Kiribati',
            '': 'Kiribati',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: '',
            languageAlpha3Code: 'gil',
            isAdministrative: true,
        },
    ],
    subdivisions: {
        'KI-G': {
            numericCode: '296',
            code: 'KI-G',
            category: {
                id: '431',
                names: {
                    en: {
                        singular: 'group of islands (20 inhabited islands)',
                        plural: 'groups of islands (20 inhabited islands)',
                    },
                    fr: {
                        singular: 'groupe d’îles (20 îles habitées)',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Gilbert Islands',
            },
        },
        'KI-L': {
            numericCode: '296',
            code: 'KI-L',
            category: {
                id: '431',
                names: {
                    en: {
                        singular: 'group of islands (20 inhabited islands)',
                        plural: 'groups of islands (20 inhabited islands)',
                    },
                    fr: {
                        singular: 'groupe d’îles (20 îles habitées)',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Line Islands',
            },
        },
        'KI-P': {
            numericCode: '296',
            code: 'KI-P',
            category: {
                id: '431',
                names: {
                    en: {
                        singular: 'group of islands (20 inhabited islands)',
                        plural: 'groups of islands (20 inhabited islands)',
                    },
                    fr: {
                        singular: 'groupe d’îles (20 îles habitées)',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                en: 'Phoenix Islands',
            },
        },
    },
    cities: [
        {
            name: 'Tarawa',
            subdivision: 'Gilbert Islands',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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